<template lang="pug">
portal.portal(selector="#attend-portal")
  AttendPage 
</template>

<script>
import AttendPage from "../Event/AttendPage.vue"
export default {
  name: "PortalAttend",
  components: { AttendPage },
}
</script>
<style lang="sass">
#attend-portal
  width: 100% !important
</style>
